







































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch, Ref, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import PrefillReviewList, {
  PrefillReviewItem
} from "@/components/prefill/PrefillReviewList.vue";
import FormPrefillService from "@/services/FormPrefillService";
import { storeDokter } from "@/store/modules/dokter";
import AsesmenNyeri from "@/components/AsesmenAwalGadar/AsesmenNyeri.vue";
import TandaVital from "@/components/AsesmenAwalGadar/TandaVital.vue";
import { TTV } from "@/types/asesmen";
import { Nyeri } from "@/types/asesmen";
import { storeUnit } from "@/store/modules/unit";
import { storeFaskes } from "@/store/modules/faskes";
import { userModule } from "@/store/modules/user";
import DiagnosisPanel from "@/components/DiagnosisICDPanel.vue";
import ProcedurePanel from "@/components/ProcedureICDPanel.vue";
import ResumeRanapSvc from "@/services/ResumeRanap";
import { appModule } from "@/store/modules/app";
import ResumeRanapStore from "@/store/modules/ResumeRanapStore";
import moment from "moment";
import ModalResumeOptionItem from "@/components/modal/ModalResumeOptionItem.vue";
import SuketKematian from "@/store/modules/SuketKematian";
import { storeSuratRujukanRanap } from "@/store/modules/SuratRujukanRanap";
import SuketKematianTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketKematianTabPage.vue";
import CardSuratRujukanRanap from "@/components/pemeriksaan/konsulRujukan/CardSuratRujukanRanap.vue";
import { storeHasilPenunjang } from "@/store/modules/HasilPenunjang";
import { confirmRemove } from "@/utility/CommonHelper";
import { isEmpty } from "lodash";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import TandaVitalTable from "@/components/TandaVitalTable.vue";
import storeBilling from "@/store/modules/Billing";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import TableHasilRadiologiForResume from "@/components/TableHasilRadiologiForResume.vue";
import TableHasilLabForResume from "@/components/TableHasilLabForResume.vue";
import TableHasilPenunjangLainForResume from "@/components/TableHasilPenunjangLainForResume.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import { storePenunjang } from "@/store/modules/penunjang";
import { PenunjangLainResult } from "@/types/penunjang_result";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import PreviewPDFModal from "@/components/PreviewPDFModal.vue";
import ResumeCetakMenu from "@/components/resume/ResumeCetakMenu.vue";
import CetakResumeSvc from "@/services/CetakResume";
import EncounterIndexStore from "@/store/modules/EncounterIndex";
import TglKontrolSkdpDatePicker from "@/components/form_components/TglKontrolSkdpDatePicker.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

interface ItemHasil {
  id: string;
  nama: string;
}

@Component({
  components: {
    AsesmenNyeri,
    TandaVital,
    DiagnosisPanel,
    ProcedurePanel,
    ModalResumeOptionItem,
    SuketKematianTabPage,
    CardSuratRujukanRanap,
    TandaVitalTable,
    TableHasilRadiologiForResume,
    TableHasilLabForResume,
    CardModalTtd,
    TableHasilPenunjangLainForResume,
    PreviewPDFModal,
    ResumeCetakMenu,
    TglKontrolSkdpDatePicker,
    VCDateTimePicker,
    PrefillReviewList
  },
  inject: {
    isReadOnly: {
      from: "isReadOnlyDokumenPulang",
      default: () => () => false
    }
  }
})
export default class ResumeRanap extends Mixins(PrefillMixin) {
  @Prop() readonly register;
  @Prop() readonly rm;
  isReadOnly!: () => boolean;

  // ── Soft-prefill (FormPrefill engine) ──────────────────────────────
  prefillFormKey = "resume_ranap";

  /** Resume tidak punya field scalar yang di-merge otomatis — hanya
   *  daftar saran obat pulang (ReviewList). */
  prefillResolvePath() {
    return { get: () => "__skip__", set: () => undefined };
  }

  get prefillObatKronikList(): PrefillReviewItem[] {
    const p = this.prefillPayload;
    return p && p.fields ? p.fields["riwayat.obat_kronik_list"] || [] : [];
  }

  applyObatPulang(items: PrefillReviewItem[]) {
    const lines = items.map(it => it.value).filter(Boolean);
    if (lines.length === 0) return;
    const existing = (this.obatPulang || "").trim();
    this.obatPulang = existing
      ? existing + "\n" + lines.join("\n")
      : lines.join("\n");
    FormPrefillService.logAcceptance({
      form_key: this.prefillFormKey,
      pasien_rm: String(this.rm),
      register_id: this.register,
      unit_id: userModule.user ? userModule.user.unit_id : null,
      event: "partial",
      fields: ["riwayat.obat_kronik_list"],
      provenance: {},
      sources: this.prefillPayload ? this.prefillPayload.sources : []
    });
  }
  // ───────────────────────────────────────────────────────────────────

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  @Ref() pdfEl: any;

  resumeId = null;
  tglMasuk = null;
  tglKeluar = null;
  dpjp = null;
  drKonsulan = [];
  drRaber = [];
  indikasiRanap = null;
  keluhanUtama = null;
  riwayatPenyakit = null;
  ringkasanFisik = null;
  ringkasanPenunjang = null;
  diagnosis: Array<{
    id: number;
    icd: string;
    diag: string;
    kasus: string;
    pasien_rm: string;
    register_id: string | number;
    unit_id: string;
  }> = [];
  diagnosisText = null;
  tindakan = null;
  obatRanap = null;
  obatPulang = null;
  caraPulang = null;

  ttvId = null;
  sistole = null;
  diastole = null;
  nadi = null;
  nafas = null;
  suhu = null;
  saturasiO2 = null;
  kesadaran = null;

  nyeriId = null;
  nyeriSkala = null;
  nyeriLokasi = null;
  nyeriFrekuensi = null;
  nyeriDurasi = null;
  nyeriPencetus = null;
  nyeriKualitas = null;
  nyeriPolaSerangan = null;
  nyeriPenyebabHilang = null;
  nyeriJenis = null;

  instruksi = null;

  unitKontrol = null;
  tglKontrol = null;

  tujuanRujukan = null;
  unitTujuanRujukan = null;

  waktuMeninggal = null;

  showTglKontrolPicker = false;
  showTglMasukPicker = false;
  showTglKeluarPicker = false;
  isNeedKontrol = false;

  diagICD: Array<{
    id: number;
    icd: string;
    diag: string;
    kasus: string;
    pasien_rm: string;
    register_id: string | number;
    unit_id: string;
  }> = [];
  procedureICD = [];

  saving = false;
  removing = false;
  signing = false;
  modalListObatDirawatShowed = false;
  modalListObatPulangShowed = false;
  modalListObatShowed = false;
  modalListObatCategory = "";
  modalListObatTitle = "";

  checkedAllRad = false;
  checkedItemsRad = null;
  checkedAllLab = false;
  checkedItemsLab: Array<any> = [];
  suketActive = null;
  maxTglKeluar = moment()
    .add(2, "day")
    .format("YYYY-MM-DD");
  modalTtdShowed = false;

  roAccNumber = [];
  selectedRoAccNumber = [];

  lisSampelId = [];
  selectedLisSampelId = [];
  selectedLisSubItems = [];

  selectedPenunjangLainItems: PenunjangLainResult[] = [];
  penunjangLainIds = [];
  showPreviewFormModal = false;
  pdfUrl: string | null = null;
  memuatPratinjau = false;

  get listObatItem() {
    return storeHasilPenunjang.listTrxObat;
    // return this.transaksiFarmasiDummy;
  }

  get listObatPulangItem() {
    // get only jenis obat
    return this.listObatItem
      .filter(item => item?.jenis_resep == "4")
      .sort((a, b) => {
        return (
          new Date(b.tgl_trans).getTime() - new Date(a.tgl_trans).getTime()
        );
      })
      .map(trx => trx.items)
      .flatMap(item => {
        return item;
      })
      .filter(item => item.jenis === "obat");
  }

  get listItemsRad() {
    // return storeHasilPenunjang.listRadiologi;
    return storeHasilPenunjang.listHasilRadiologi;
  }

  get listItemsLab() {
    // return storeHasilPenunjang.listLab;
    return storeHasilPenunjang.listHasilLab;
  }

  get suketButtons() {
    return [
      {
        type: "suket-mati",
        title: "Suket Kematian",
        component: "SuketKematianTabPage",
        data: SuketKematian.suket,
        store: SuketKematian,
        canInstantCreate: true
      },
      {
        type: "rujukan-ranap",
        title: "Surat Rujukan",
        component: "CardSuratRujukanRanap",
        data: storeSuratRujukanRanap.rujukan,
        store: storeSuratRujukanRanap,
        canInstantCreate: true
      }
    ];
  }

  get disableSuketButtons() {
    return !this.resumeId;
  }

  get regKunjungan() {
    return RegisterKunjungan.register;
  }

  get canWrite() {
    if (this.readOnly) return false;
    return !this.storeResumeData?.signed_at;
  }

  get canSign() {
    if (this.readOnly) return false;
    return (
      this.dpjp == this.stateUser.id &&
      this.storeResumeData &&
      !this.storeResumeData.signed_at
    );
  }

  get canDelete() {
    if (this.readOnly) return false;
    return this.resumeId && this.dpjp == this.stateUser.id;
  }

  get maxTglKontrol() {
    return moment(this.minTglKontrol, "YYYY-MM-DD")
      .add(14, "days")
      .format("YYYY-MM-DD");
  }
  get minTglKontrol() {
    return moment(this.tglKeluar)
      .add(1, "day")
      .format("YYYY-MM-DD");
  }

  showSuketContent(type) {
    this.suketActive = type;

    if (type == "suket-mati") {
      SuketKematian.getSuketByRegister(this.register);
    }

    if (type == "rujukan-ranap") {
      storeSuratRujukanRanap.getByRegister(this.register);
    }
  }

  @Watch("isNeedKontrol")
  changeisNeedKontrol(val) {
    if (!val) {
      this.unitKontrol = null;
    }
  }

  @Watch("checkedAllRad")
  changeCheckedAllRad(val) {
    if (!val) {
      this.checkedItemsRad = null;
    } else {
      this.checkedItemsRad = this.listItemsRad;
    }
  }

  @Watch("checkedAllLab")
  changeCheckedAllLab(val) {
    if (!val) {
      this.checkedItemsLab = null;
    } else {
      this.checkedItemsLab = this.listItemsLab.map(item => item.hasil).flat();
    }
  }

  @Watch("caraPulang")
  changeCaraPulang(val) {
    if (val) {
      if (val == 1) {
        this.tujuanRujukan = null;
        this.waktuMeninggal = null;
      } else if (val == 2) {
        this.unitKontrol = null;
        this.tglKontrol = null;
        this.waktuMeninggal = null;
        this.isNeedKontrol = false;
      } else if (val == 4) {
        this.unitKontrol = null;
        this.tglKontrol = null;
        this.tujuanRujukan = null;
        this.isNeedKontrol = false;
      } else {
        this.unitKontrol = null;
        this.tglKontrol = null;
        this.tujuanRujukan = null;
        this.waktuMeninggal = null;
        this.isNeedKontrol = false;
      }
    }
  }

  get listDokter() {
    return storeDokter.list;
  }

  get faskesList() {
    return storeFaskes.faskes;
  }

  caraPulangOptions = [
    { id: 1, name: "Atas ijin dokter" },
    { id: 2, name: "Dirujuk" },
    { id: 3, name: "Atas permintaan sendiri" },
    { id: 4, name: "Meninggal dunia" },
    { id: 6, name: "Melarikan diri" }
  ];

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id" };
  selectProps = { openOnHover: true, offsetY: true };

  get valTtv(): TTV {
    return {
      sistole: this.sistole,
      diastole: this.diastole,
      nadi: this.nadi,
      nafas: this.nafas,
      suhu: this.suhu,
      saturasiO2: this.saturasiO2,
      kesadaran: this.kesadaran
    };
  }

  set valTtv(val: TTV) {
    console.log("set compute valTtv", val);
    this.sistole = val.sistole;
    this.diastole = val.diastole;
    this.nadi = val.nadi;
    this.nafas = val.nafas;
    this.suhu = val.suhu;
    this.saturasiO2 = val.saturasiO2;
    this.kesadaran = val.kesadaran;
  }

  get valNyeri(): Nyeri {
    return {
      skala: this.nyeriSkala,
      lokasi: this.nyeriLokasi,
      frekuensi: this.nyeriFrekuensi,
      durasi: this.nyeriDurasi,
      pencetus: this.nyeriPencetus,
      kualitas: this.nyeriKualitas,
      pola_serangan: this.nyeriPolaSerangan,
      penyebab_hilang: this.nyeriPenyebabHilang,
      jenis: this.nyeriJenis
    };
  }

  set valNyeri(val: Nyeri) {
    this.nyeriSkala = val.skala;
    this.nyeriLokasi = val.lokasi;
    this.nyeriFrekuensi = val.frekuensi;
    this.nyeriDurasi = val.durasi;
    this.nyeriPencetus = val.pencetus;
    this.nyeriKualitas = val.kualitas;
    this.nyeriPolaSerangan = val.pola_serangan;
    this.nyeriPenyebabHilang = val.penyebab_hilang;
    this.nyeriJenis = val.jenis;
  }

  get unitRalan() {
    return storeUnit.unitPagi;
  }

  loadingListItemLab = false;

  get requestParams() {
    return {
      pasien_rm: this.rm,
      register_id: this.register,
      unit_id: this.stateUser.unit_id,
      tgl_masuk: this.tglMasuk,
      tgl_keluar: this.tglKeluar,
      dpjp_id: this.dpjp,
      dr_konsulan: this.drKonsulan,
      dr_raber: this.drRaber,
      keluhan_utama: this.keluhanUtama,
      indikasi_ranap: this.indikasiRanap,
      riwayat_penyakit: this.riwayatPenyakit,
      ringkasan_fisik: this.ringkasanFisik,
      diagnosis_text: this.diagnosisText,
      diagnosis: this.diagICD.map((item, index) => {
        return {
          kode: item.icd,
          tgl: moment().format("YYYY-MM-DD"),
          unit_id: this.stateUser.unit_id,
          dr_id: this.dpjp,
          urut: index + 1,
          kasus: item.kasus
        };
      }),
      tindakan: this.tindakan,
      obat_ranap: this.obatRanap,
      obat_pulang: this.obatPulang,
      tanda_vital_id: this.selectedTtv.length ? this.selectedTtv[0].id : null,
      ro_acc_number: this.selectedRoAccNumber.map(item => item.acc_number),
      lis_sampel_id: this.selectedLisSampelId.map(item => item.lis_sampel),
      lis_sampel_items: this.selectedLisSubItems,
      penunjang_lain_id: this.selectedPenunjangLainItems.map(item => item.id),
      nyeri: this.isAnyAsesNyeriInputed
        ? {
            id: this.nyeriId,
            skala: this.nyeriSkala,
            lokasi: this.nyeriLokasi,
            frekuensi: this.nyeriFrekuensi,
            durasi: this.nyeriDurasi,
            pencetus: this.nyeriPencetus,
            kualitas: this.nyeriKualitas,
            pola_serangan: this.nyeriPolaSerangan,
            penyebab_hilang: this.nyeriPenyebabHilang,
            jenis: this.nyeriJenis,
            unit_id: this.stateUser.unit_id
          }
        : null,
      discharge_id: this.caraPulang,
      instruksi: this.instruksi,
      unit_kontrol_id: this.unitKontrol,
      tgl_kontrol: this.tglKontrol,
      faskes_rujukan_id: this.tujuanRujukan,
      unit_rujukan: this.unitTujuanRujukan,
      waktu_meninggal: this.waktuMeninggal
        ? moment(this.waktuMeninggal).format("YYYY-MM-DD HH:mm:ss")
        : null,
      surat_date: this.tglKeluar
    };
  }

  get stateUser() {
    return userModule.user;
  }

  get isAnyAsesNyeriInputed() {
    if (
      this.nyeriId ||
      this.nyeriSkala ||
      this.nyeriLokasi ||
      this.nyeriFrekuensi ||
      this.nyeriDurasi ||
      this.nyeriPencetus ||
      this.nyeriKualitas ||
      this.nyeriPolaSerangan ||
      this.nyeriPenyebabHilang ||
      this.nyeriJenis
    ) {
      return true;
    } else {
      return false;
    }
  }

  get isAnyTtvInputed() {
    if (
      this.ttvId ||
      this.sistole ||
      this.diastole ||
      this.nadi ||
      this.nafas ||
      this.suhu ||
      this.saturasiO2 ||
      this.kesadaran
    ) {
      return true;
    } else {
      return false;
    }
  }

  get signedAt() {
    return this.storeResumeData
      ? moment(this.storeResumeData.signed_at).format("DD-MM-YYYY HH:mm")
      : null;
  }

  get soapList() {
    return SoapRanapStore.soapList.sort((a, b) => {
      return (
        new Date(b.examined_at).getTime() - new Date(a.examined_at).getTime()
      );
    });
  }

  get soapDpjp() {
    return this.soapList.filter(soap => soap.user_id == this.dpjp);
  }

  get listDokterId() {
    return this.listDokter.map(it => it.id);
  }

  get soapDrRaber() {
    return this.soapList.filter(soap => {
      return (
        soap.user_id != this.dpjp &&
        !["01", "02", "37"].includes(soap.unit_id) &&
        this.listDokter
          .filter(it => it.idsp > 0)
          .map(it => it.id)
          .includes(parseInt(soap.user_id.toString()))
      );
    });
  }

  get storeResumeData() {
    return ResumeRanapStore.resume;
  }

  get storeResumeLoading() {
    return ResumeRanapStore.loading;
  }

  get storeAsesmenMedis() {
    return AsesmenAwalRanapMedisStore.asesmen;
  }

  async mounted() {
    await TandaVitalStore.getByRegister(this.register);

    this.getByRegister();

    storeHasilPenunjang.getObatByRegister(this.register);
    storeHasilPenunjang.getLabByRegister(this.register);
    storeHasilPenunjang.getRadiologiByRegister(this.register);
    // store penunjang lain baiknya bisa bareng di store yang baru...
    storePenunjang.act_penunjang_lain_byReg(this.register);
    AsesmenAwalRanapMedisStore.getByRegister(this.register);
  }

  setTtv(val: TTV) {
    this.valTtv = val;
    console.log("set ttv", val);
  }

  setNyeri(val: Nyeri) {
    this.valNyeri = val;
    console.log("set nyeri", val);
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const request = this.resumeId
        ? ResumeRanapSvc.update(this.resumeId, this.requestParams)
        : ResumeRanapSvc.create(this.requestParams);

      request
        .then(() => {
          appModule.NoticeDelay("Berhasil Simpan Resume Ranap");

          this.getByRegister();
        })
        .finally(() => {
          this.saving = false;
        });
    } else {
      alert("proses simpan sedang berjalan...");
    }
  }

  remove() {
    if (!this.removing) {
      const confirmed = confirmRemove("Resume Rawat Inap");

      if (confirmed) {
        this.removing = true;

        ResumeRanapSvc.destroy(this.resumeId)
          .then(() => {
            // set store module

            appModule.NoticeDelay("Berhasil Hapus Resume Ranap");

            this.getByRegister();
          })
          .finally(() => {
            this.removing = false;
          });
      }
    }
  }

  signResume(value) {
    if (!this.signing) {
      this.signing = true;

      ResumeRanapSvc.sign(this.resumeId, { password: value })
        .then(resp => {
          const dt = resp.data;

          if (dt.status == 1) {
            appModule.NoticeDelay("Berhasil Tanda Tangan Surat Keterangan");
            appModule.addMsgTtd("");

            this.getByRegister();
          } else {
            appModule.sendErrorAlert(dt.message);
          }
        })
        .finally(() => {
          this.signing = false;
          this.modalTtdShowed = false;
        });
    }
  }

  async getByRegister() {
    await ResumeRanapStore.getByRegister(this.register);

    const data = this.storeResumeData;

    if (data) {
      this.resumeId = data.id;
      this.tglMasuk = data.tgl_masuk;
      this.tglKeluar = data.tgl_keluar;
      this.dpjp = parseInt(data.dpjp_id.toString());
      this.drKonsulan = data.dr_konsulan;
      this.drRaber = data.dr_raber;
      this.indikasiRanap = data.indikasi_ranap;
      this.keluhanUtama = data.keluhan_utama;
      this.riwayatPenyakit = data.riwayat_penyakit;
      this.ringkasanFisik = data.ringkasan_fisik;
      this.ringkasanPenunjang = data.ringkasan_penunjang;
      this.diagnosisText = data.diagnosis_text;
      this.tindakan = data.tindakan;
      this.obatRanap = data.obat_ranap;
      this.obatPulang = data.obat_pulang;

      if (data.diagnosis && data.diagnosis.length > 0) {
        // this.diagICD = data.diagnosis;
        const diag = [];

        data.diagnosis.forEach(el => {
          diag.push({
            diag: el.title,
            icd: el.code,
            kasus: el.kasus,
            id: el.id,
            pasien_rm: this.rm,
            register_id: this.register,
            unit_id: el.unit_id,
            dr_id: el.dr_id,
            tgl: el.tgl
          });
        });

        this.diagICD = diag;
      }

      this.ttvId = data.tanda_vital?.id;

      if (data.nyeri) {
        this.nyeriId = data.nyeri.id;
        this.nyeriSkala = data.nyeri.skala;
        this.nyeriLokasi = data.nyeri.lokasi;
        this.nyeriFrekuensi = data.nyeri.frekuensi;
        this.nyeriDurasi = data.nyeri.durasi;
        this.nyeriPencetus = data.nyeri.pencetus;
        this.nyeriKualitas = data.nyeri.kualitas;
        this.nyeriPolaSerangan = data.nyeri.pola_serangan;
        this.nyeriPenyebabHilang = data.nyeri.penyebab_hilang;
        this.nyeriJenis = data.nyeri.jenis;
      } else {
        this.nyeriId = null;
        this.nyeriSkala = null;
        this.nyeriLokasi = null;
        this.nyeriFrekuensi = null;
        this.nyeriDurasi = null;
        this.nyeriPencetus = null;
        this.nyeriKualitas = null;
        this.nyeriPolaSerangan = null;
        this.nyeriPenyebabHilang = null;
        this.nyeriJenis = null;
      }

      this.lisSampelId = data.lab_result.map(item => item.lis_sampel);
      this.selectedLisSubItems = data.lis_sampel_items ?? [];
      this.roAccNumber = data.radiologi_result.map(item => item.acc_number);
      this.penunjangLainIds = data.penunjang_lain_result?.map(item => item.id);

      this.caraPulang = parseInt(data.discharge_id.toString());
      this.instruksi = data.instruksi;

      if (data.discharge_id == 1) {
        this.isNeedKontrol = !isEmpty(data.unit_kontrol_id);
        this.unitKontrol = data.unit_kontrol_id;
        this.tglKontrol = data.tgl_kontrol;
      } else if (data.discharge_id == 2) {
        this.tujuanRujukan = data.faskes_rujukan_id;
        this.unitTujuanRujukan = data.unit_rujukan;
      } else if (data.discharge_id == 4) {
        this.waktuMeninggal = new Date(data.waktu_meninggal);
      }
    } else {
      this.clearInput();

      // Record baru: tarik saran obat pulang dari CPO (ReviewList —
      // diverifikasi petugas, tidak auto-commit). Dipanggil SEBELUM
      // setFormInputDefaultVal() yang bisa throw saat regKunjungan
      // belum termuat (race pre-existing) — jangan sampai memblokir prefill.
      if (!this.readOnly) {
        this.$nextTick(() => {
          this.loadPrefill({
            pasien_rm: String(this.rm),
            register_id: this.register,
            unit_id: userModule.user ? userModule.user.unit_id : undefined
          });
        });
      }

      this.setFormInputDefaultVal();
    }
  }

  setFormInputDefaultVal() {
    this.tglMasuk = this.regKunjungan.jurnal_ranap[0]?.tgl_in;
    this.dpjp = this.regKunjungan.dokter.id;
    // this.drRaber = this.lastSoapDrRaber.map(it => it.user_id);
    this.drRaber = this.drRaberIdsByEncounter.length
      ? this.drRaberIdsByEncounter
      : this.drRaberIdsBySoap;
    this.drKonsulan = this.drKonsulIdsByEncounter;

    storeBilling.getDiagnosis(this.register).then(() => {
      if (
        storeBilling.diagnosis &&
        storeBilling.diagnosis?.diagnosis.length > 0
      ) {
        const dataDiag = storeBilling.diagnosis.diagnosis;

        const diag = [];

        dataDiag.forEach(el => {
          diag.push({
            diag: el.nama,
            icd: el.kode,
            kasus: el.kasus,
            id: null,
            pasien_rm: this.rm,
            register_id: this.register,
            unit_id: el.unit_id,
            dr_id: el.dr_id,
            tgl: el.tgl
          });
        });

        this.diagICD = diag;
      }
    });

    if (this.listObatPulangItem.length > 0) {
      console.log("set obat pulang....");
      const listObat = this.getObatItemsString(this.listObatPulangItem);
      console.log(listObat);
      this.setItemObat(listObat, "pulang");
    }
  }

  getObatItemsString(item): string[] {
    return item.map(it => {
      return (
        it?.nama +
        " " +
        it?.qty +
        " " +
        it?.satuan +
        (it.aturan_pakai ? " " + it.aturan_pakai.nama : "")
      );
    });
  }

  saveDiagsICD() {
    //
  }

  saveProceduresICD() {
    //
  }

  changeDiags(val) {
    this.diagICD = val;
  }

  changeProcedures(val) {
    this.procedureICD = val;
  }

  clearInput() {
    this.resumeId = null;
    this.tglMasuk = null;
    this.tglKeluar = null;
    this.dpjp = null;
    this.drKonsulan = null;
    this.drRaber = null;
    this.keluhanUtama = null;
    this.indikasiRanap = null;
    this.riwayatPenyakit = null;
    this.ringkasanFisik = null;
    this.ringkasanPenunjang = null;
    this.diagnosis = null;
    this.diagnosisText = null;
    this.tindakan = null;
    this.obatRanap = null;
    this.obatPulang = null;

    this.roAccNumber = [];
    this.lisSampelId = [];
    this.penunjangLainIds = [];
    this.selectedLisSubItems = [];
    this.ttvId = null;
    this.sistole = null;
    this.diastole = null;
    this.suhu = null;
    this.nadi = null;
    this.nafas = null;
    this.saturasiO2 = null;
    this.kesadaran = null;

    this.nyeriId = null;
    this.nyeriSkala = null;
    this.nyeriLokasi = null;
    this.nyeriFrekuensi = null;
    this.nyeriDurasi = null;
    this.nyeriPencetus = null;
    this.nyeriKualitas = null;
    this.nyeriPolaSerangan = null;
    this.nyeriPenyebabHilang = null;
    this.nyeriJenis = null;

    this.caraPulang = null;
    this.instruksi = null;
    this.unitKontrol = null;
    this.tglKontrol = null;
    this.tujuanRujukan = null;
    this.unitTujuanRujukan = null;
    this.waktuMeninggal = null;
  }

  async previewForm() {
    if (!this.resumeId || this.memuatPratinjau) {
      return;
    }

    this.memuatPratinjau = true;
    this.showPreviewFormModal = false;
    this.lepasPdfUrl();

    try {
      this.pdfUrl = await CetakResumeSvc.pratinjau("ranap", this.resumeId);
      this.showPreviewFormModal = true;
    } catch (e) {
      return;
    } finally {
      this.memuatPratinjau = false;
    }
  }

  @Watch("showPreviewFormModal")
  onPreviewFormModal(terbuka: boolean) {
    if (!terbuka) {
      this.lepasPdfUrl();
    }
  }

  lepasPdfUrl() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
      this.pdfUrl = null;
    }
  }

  beforeDestroy() {
    this.lepasPdfUrl();
  }

  showListObatModal(cat) {
    this.modalListObatCategory = cat;
    if (cat === "dirawat") {
      this.modalListObatTitle = "Pilih obat selama dirawat";
    } else if (cat === "pulang") {
      this.modalListObatTitle = "Pilih obat dibawa pulang";
    } else {
      this.modalListObatTitle = "";
    }
    this.modalListObatShowed = true;
  }

  setItemObat(val: string[], cat) {
    const pastedItem = val
      .filter(string => string !== null && string !== undefined)
      .join(";\r\n");

    if (cat === "dirawat") {
      this.obatRanap = this.obatRanap
        ? this.obatRanap + ";\r\n" + pastedItem
        : pastedItem;
    } else if (cat === "pulang") {
      this.obatPulang = this.obatPulang
        ? this.obatPulang + ";\r\n" + pastedItem
        : pastedItem;
    }
  }

  selectedTtv = [];

  getKeluhanAsesmenMedis() {
    if (this.storeAsesmenMedis) {
      this.keluhanUtama = this.storeAsesmenMedis.keluhan_utama;
    } else {
      appModule.sendErrorAlert(
        "Asesmen Awal Ranap belum diisi. Tidak ada yg bisa di copy!"
      );
    }
  }

  getRpsAsesmenMedis() {
    if (this.storeAsesmenMedis) {
      this.riwayatPenyakit = this.storeAsesmenMedis.riwayat_penyakit_sekarang;
    } else {
      appModule.sendErrorAlert(
        "Asesmen Awal Ranap belum diisi. Tidak ada yg bisa di copy!"
      );
    }
  }

  getFisikAsesmenMedis() {
    if (this.storeAsesmenMedis) {
      let antro = "",
        pFisik = "";
      if (this.storeAsesmenMedis.antropometri) {
        const dt = this.storeAsesmenMedis.antropometri,
          bb = dt.berat_badan ? `BB: ${dt.berat_badan}kg` : "",
          tb = dt.tinggi_badan ? `TB: ${dt.tinggi_badan}cm` : "",
          bbl = dt.bbl ? `BBL: ${dt.bbl}kg` : "";

        antro = [bb, tb, bbl].join(" ").trim();
      }

      if (this.storeAsesmenMedis?.pemeriksaan_fisik) {
        const fisik = [];
        for (const [key, value] of Object.entries(
          this.storeAsesmenMedis.pemeriksaan_fisik
        )) {
          // print key and value on console
          if (
            value &&
            [
              "kepala",
              "leher",
              "dada",
              "jantung",
              "paru",
              "perut",
              "ektrimita_atas",
              "ektrimita_bawah",
              "status_pubertas",
              "genital",
              "tubuh_belakang"
            ].includes(key)
          ) {
            let title = "";
            if (key == "ektrimita_atas") {
              title = "ekstremitas atas";
            } else if (key == "ektrimita_bawah") {
              title = "ekstremitas bawah";
            } else {
              title = key.replace("_", " ");
            }

            fisik.push(`${title}: ${value}`);
          }
        }

        pFisik = fisik.join("; ");
      }

      this.ringkasanFisik = [antro, pFisik].join("\r\n").trim();
    } else {
      appModule.sendErrorAlert(
        "Asesmen Awal Ranap belum diisi. Tidak ada yg bisa di copy!"
      );
    }
  }

  get lastSoapDrRaber() {
    return this.soapDrRaber.reduce((arr, item) => {
      if (!arr.find(it => it.user_id == item.user_id)) {
        arr.push({
          user_id: parseInt(item.user_id.toString()),
          assesment: item.assesment,
          plan: item.plan
        });
      }

      return arr;
    }, [] as Array<{ user_id: number; assesment: string; plan: string }>);
  }

  get drRaberIdsBySoap() {
    return this.lastSoapDrRaber.map(it => it.user_id);
  }

  get drRaberIdsByEncounter() {
    return EncounterIndexStore.encRanapParticipantByRole.raber.map(it =>
      parseInt(it.user_id)
    );
  }

  get drKonsulIdsByEncounter() {
    return EncounterIndexStore.encRanapParticipantByRole.konsul.map(it =>
      parseInt(it.user_id)
    );
  }

  getAsesmenSoapTerakhir() {
    const asesDpjp = this.soapDpjp.length ? this.soapDpjp[0].assesment : null;
    const asesRaber = this.lastSoapDrRaber.map(it => it.assesment);
    const ases: Array<string> = asesDpjp ? [asesDpjp, ...asesRaber] : asesRaber;

    // get asesmen SOAP terakhir yg dibikin DPJP
    if (ases.length > 0) {
      this.diagnosisText = ases.join("\r\n");
    } else {
      alert("tidak ada isian Asesmen SOAP yang bisa diambil....");
    }
  }

  getPlanSoapTerakhir() {
    const planDpjp = this.soapDpjp.length ? this.soapDpjp[0].plan : null;
    // const planRaber = this.lastSoapDrRaber.map(it => it.plan);
    const planRaber = [];
    const plan: Array<string> = planDpjp ? [planDpjp, ...planRaber] : planRaber;

    // get plan SOAP terakhir yg dibikin DPJP
    if (plan.length > 0) {
      this.tindakan = this.soapDpjp[0].plan;
    } else {
      alert("tidak ada isian Plan SOAP yang bisa diambil....");
    }
  }

  setTglKontrol(val) {
    this.tglKontrol = val;
  }

  datetimeInput() {
    const dtime = new Date();
    if (this.waktuMeninggal > dtime) {
      this.$nextTick(() => {
        this.waktuMeninggal = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }
}
